import { contentConstants } from "./constant"



export const imagesapi = (state) => async (dispatch) => {
    dispatch({
        type: contentConstants.IMAGES,
        payload: state,
    });

};

export const contentapi = (state) => async (dispatch) => {
    dispatch({
        type: contentConstants.CONTENT,
        payload: state,
    });

};
export const appContentapiLoading = (state) => async (dispatch) => {
    dispatch({
        type: contentConstants.APP_CONTENT,
        payload: state,
    });

};

export const loginApiLoading = (state) => async (dispatch) => {
    dispatch({
        type: contentConstants.FOOTER_CONTENT,
        payload: state,
    });

};

export const faqApiLoading = (state) => async (dispatch) => {
    dispatch({
        type: contentConstants.FAQ,
        payload: state,
    });

};

export const announcementApiLoading = (state) => async (dispatch) => {
    dispatch({
        type: contentConstants.ANNOUNCEMENT,
        payload: state,
    });

};

export const linksApiLoading = (state) => async (dispatch) => {
    dispatch({
        type: contentConstants.LINKS,
        payload: state,
    });

};

export const desktopbackgroundimg = (state) => async (dispatch) => {
    dispatch({
        type: contentConstants.DESKTOP_IMG,
        payload: state,
    });

};